import "moment-timezone";
import moment from "moment";
import { AIRLINE_CODES } from "../../helpers/airline-codes";
import React, { useCallback } from "react";
import { MenuItem } from "@blueprintjs/core";
import { Icon } from "antd";
import _ from "lodash";

function GoogleLogoIcon() {
  return <Icon type="google" />;
}

function addBooleans(bools) {
  return _.sum(bools.map(v => (v ? 1 : 0)));
}

export function makeFlightsSearchUrl(site, data) {
  const isRoundtrip = _.isUndefined(data.carrier_0);

  if (site === "kiwi" && !isRoundtrip) {
    const hasFirstStop = data["stop_0"] && data["stop_0"].length;
    const hasSecondStop = data["stop_1"] && data["stop_1"].length;
    const nStops = addBooleans([hasFirstStop, hasSecondStop]);

    const date = moment(data.departs_at)
      .tz("UTC")
      .format("YYYY-MM-DD");
    const airlineCode = AIRLINE_CODES[data.carrier_0];

    const min_d = moment(data.departs_at)
      .tz("UTC")
      .subtract(4, "hours")
      .format("HH");
    const max_d = moment(data.departs_at)
      .tz("UTC")
      .add(4, "hours")
      .format("HH");
    const min_a = moment(data.arrives_at)
      .tz("UTC")
      .subtract(4, "hours")
      .format("HH");
    const max_a = moment(data.arrives_at)
      .tz("UTC")
      .add(4, "hours")
      .format("HH");
    const times = `${min_d}-${max_d}-${min_a}-${max_a}`;

    // console.log({
    //   min_d,
    //   max_d,
    //   min_a,
    //   max_a,
    //   departs_at: data.departs_at,
    //   arrives_at: data.arrives_at,
    //   m_departs_at: moment(data.departs_at),
    //   m_arrives_at: moment(data.arrives_at)
    // });

    return `https://www.kiwi.com/us/search/results/${data.orig}/${data.dest}/${date}/no-return?adults=8&airlinesList=${airlineCode}&children=0&infants=0&selectedAirlinesExclude=false&stopNumber=${nStops}&stopDurationMax=3&transport=aircraft&times=${times}`;
  } else if (site === "gflights" && isRoundtrip) {
    const f1__hasFirstStop = data["f1__stop_0"] && data["f1__stop_0"].length;
    const f1__hasSecondStop = data["f1__stop_1"] && data["f1__stop_1"].length;
    const f1__nStops = addBooleans([f1__hasFirstStop, f1__hasSecondStop]);

    const f2__hasFirstStop = data["f2__stop_0"] && data["f2__stop_0"].length;
    const f2__hasSecondStop = data["f2__stop_1"] && data["f2__stop_1"].length;
    const f2__nStops = addBooleans([f2__hasFirstStop, f2__hasSecondStop]);

    const f1__date = moment(data.f1__departs_at)
      .tz("UTC")
      .format("YYYY-MM-DD");
    const f2__date = moment(data.f2__departs_at)
      .tz("UTC")
      .format("YYYY-MM-DD");
    const f1__airlineCode = [
      AIRLINE_CODES[data.f1__carrier_0],
      AIRLINE_CODES[data.f1__carrier_1],
      AIRLINE_CODES[data.f1__carrier_2]
    ]
      .filter(v => !!v)
      .join(",");
    const f2__airlineCode = [
      AIRLINE_CODES[data.f2__carrier_0],
      AIRLINE_CODES[data.f2__carrier_1],
      AIRLINE_CODES[data.f2__carrier_2]
    ]
      .filter(v => !!v)
      .join(",");
    const maybeTripType = data.f1__dest === data.f2__orig ? "" : ";tt:m";
    return `https://www.google.com/flights?hl=en#flt=${data.f1__orig}.${data.f1__dest}.${f1__date}*${data.f2__orig}.${data.f2__dest}.${f2__date};c:USD;e:1;s:${f1__nStops}*${f2__nStops};a:${f1__airlineCode}*${f2__airlineCode};so:1;sd:1;t:f${maybeTripType}`;
  } else if (site === "gflights" && !isRoundtrip) {
    const hasFirstStop = data["stop_0"] && data["stop_0"].length;
    const hasSecondStop = data["stop_1"] && data["stop_1"].length;
    const nStops = addBooleans([hasFirstStop, hasSecondStop]);

    const date = moment(data.departs_at)
      .tz("UTC")
      .format("YYYY-MM-DD");
    const airlineCode = [
      AIRLINE_CODES[data.carrier_0],
      AIRLINE_CODES[data.carrier_1],
      AIRLINE_CODES[data.carrier_2]
    ]
      .filter(v => !!v)
      .join(",");
    return `https://www.google.com/flights?hl=en#flt=${data.orig}.${data.dest}.${date};c:USD;e:1;s:${nStops}*1;a:${airlineCode};so:1;sd:1;t:f;tt:o`;
  }
}

export function GflightsMenuItem({ gflightsUrl }) {
  const gotoGoogleFlights = useCallback(() => {
    window.open(gflightsUrl);
  }, [gflightsUrl]);

  return !_.size(gflightsUrl) ? null : (
    <MenuItem
      css={`
        &&& {
          align-items: center;

          .anticon-google {
            color: #a7b6c2;
          }
        }

        &&&:hover {
          .anticon-google {
            color: #f6f8fa;
          }
        }
      `}
      data-testid="view_on_google_flights_menuitem"
      icon={<GoogleLogoIcon />}
      text="View on Google Flights"
      onClick={gotoGoogleFlights}
    />
  );
}

export function KayakMenuItem({ kayakUrl }) {
  const gotoKayak = useCallback(() => {
    window.open(kayakUrl);
  }, [kayakUrl]);

  return !_.size(kayakUrl) ? null : (
    <MenuItem
      css={`
        &&& {
          align-items: center;

          .icon-kayak {
            color: #a7b6c2;
          }
        }

        &&&:hover {
          .icon-kayak {
            color: #f6f8fa;
          }
        }
      `}
      data-testid="view_on_kayak_menuitem"
      icon={
        <span
          css={`
            padding-left: 1px;
            padding-right: 3px;
            font-size: 14pt;
            font-weight: bolder;
          `}
          className="icon-kayak"
        >
          K
        </span>
      }
      text="View on Kayak"
      onClick={gotoKayak}
    />
  );
}

export function KiwiMenuItem({ kiwiUrl }) {
  const gotoKiwi = useCallback(() => {
    window.open(kiwiUrl);
  }, [kiwiUrl]);

  return !_.size(kiwiUrl) ? null : (
    <MenuItem
      css={`
        &&& {
          align-items: center;

          .icon-kiwi {
            color: #a7b6c2;
          }
        }

        &&&:hover {
          .icon-kiwi {
            color: #f6f8fa;
          }
        }
      `}
      data-testid="view_on_kiwi_menuitem"
      icon={
        <span
          css={`
            margin-left: -4px;
            margin-right: 4px;
            font-size: 14pt;
            font-weight: bolder;
          `}
          className="icon-kiwi"
        >
          <img src="/kiwi-logo.png" height="24px" alt="Kiwi Logo" />
        </span>
      }
      text="View on Kiwi"
      onClick={gotoKiwi}
    />
  );
}
